<template>
  <div class="chat-wap">
    <div v-for="(msg, index) of msgs" :key="index" class="msg-info">
      <div class="msg-photo">
        <img
          class="msg-img"
          :src="
            msg.userIcon
              ? msg.userIcon.startsWith('http')
                ? msg.userIcon
                : user.dataPath.substring(0, user.dataPath.lastIndexOf('/data')) + msg.userIcon
              : assetsUrl + 'imgs/pp.jpg'
          "
        />
      </div>
      <div class="msg-detail">
        <div class="msg-name">
          {{ msg.username }}
          <!-- <div v-if="msg.actor && (msg.userType != 'slice' || msg.userType != 'student')"></div> -->
        </div>
        <div class="msg-allow">{{ msg.content }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLiveChatInfo } from '@/api/chat'
export default {
  data() {
    return {
      assetsUrl: 'https://static.51lss.com/o2ostu/assets/',
      msgs: [],
    }
  },
  props: {},
  created() {
    this.initParam()
  },
  methods: {
    initParam() {
      const params = {
        scheduleId: this.$route.query.scheduleId,
        size: 100,
      }
      getLiveChatInfo(params).then((res) => {
        console.log(res.list)
        this.msgs = res.list
      })
      // if (this.pushType == "1") {
      //   this.checkShowHistory();
      // }
    },
  },
}
</script>
<style lang="less">
.chat-wap {
  background-color: #202127;
  border-top: 6px solid #3e3e4e;
  height: calc(100vh - 100px);
  overflow: auto;
}
.msg-info {
  display: flex;
  padding: 20px 20px 0 20px;
}
.msg-img {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 10px;
}
.msg-name {
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
  color: #848e99;
  height: 25px;
  line-height: 25px;
}
.msg-allow {
  background: #2b2c35;
  border-radius: 5px;
  padding: 8px;
  font-size: 12px;
}
</style>
